var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1246 -411)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(1246 411)",
    fill: "#4fbf26"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1260.342 373.057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.692,58.83,9.447,70.074a2.134,2.134,0,0,1-3.017,0L.624,64.269a2.133,2.133,0,0,1,3.017-3.017l4.3,4.3,9.736-9.736a2.133,2.133,0,0,1,3.017,3.017Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ad8e46b235e00d3bcdd2078855ae4ec5.svg";
export { ForwardRef as ReactComponent };